import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";

const TareaDetalleGestionarCasoVencido = React.lazy(
  () =>
    import(
      "../components/task/accountManager/tareaDetalleGestionarCasoVencido/tarea-detalle-gestionar-caso-vencido"
    )
);
const ErrorPage = React.lazy(() => import("../components/error-page"));

export function tareaDetalleGestionarCasoVencido() {
  return (
    <Route
      path="/tarea-detalle-gestionar-caso-vencido"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleGestionarCasoVencido />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
